<template>
	<div class="cookie-banner">
		<div
			v-if="!hidden"
			class="cookie-banner__wrapper"
		>
			<div
				class="cookie-banner__content"
				ref="content"
			>
				<div
					class="cookie-banner__title"
					v-html="$t('cookiebanner.title')"
				/>
				<div
					class="cookie-banner__text"
					v-html="$t('cookiebanner.text')"
				/>

				<div class="cookie-banner__buttons">
					<Button
						data-consent-submit
						:data-consent-selection="allCategoriesFormatted"
						level="primary"
						type="button"
						small
						:text="$t('cookiebanner.acceptAllButton')"
						@click="onAccept"
					/>
					<Button
						data-consent-submit
						:data-consent-selection="defaultCookieCategory"
						level="outline"
						type="button"
						small
						:text="$t('cookiebanner.acceptDefaultButton')"
						@click="onAccept"
					/>
					<Button
						:text="$t('cookiebanner.chooseButton')"
						type="button"
						level="tertiary"
						arrow
						@click="openModal"
					/>
				</div>
			</div>
		</div>

		<Modal
			overlay-type="cookie-consent"
			ref="modal"
			@open="onModalOpen"
		>
			<div class="overlay-dialog cookie-dialog">
				<h2
					class="overlay-dialog__title"
					v-html="$t('cookiebanner.settings.title')"
				/>
				<div class="cookie-dialog__inputs">
					<FormInputCheckbox
						v-for="(category, index) in cookieCategories"
						:key="index"
						v-model="selectedCategories[category]"
						:disabled="category === defaultCookieCategory"
					>
						<strong
							v-html="$t(`cookiebanner.settings.${category}.title`)"
						/>
						<div
							v-html="$t(`cookiebanner.settings.${category}.description`)"
						/>
					</FormInputCheckbox>
				</div>
				<Button
					data-consent-submit
					:data-consent-selection="selectedCategoriesFormatted"
					level="primary"
					type="button"
					small
					:text="$t('cookiebanner.settings.submitButton')"
					@click="onAccept"
				/>
			</div>
		</Modal>

	</div>
</template>

<script>
import cookie from 'cookie_js'
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import FormInputCheckbox from '@/components/FormInputCheckbox';

export default {
	components: {
		Button,
		Modal,
		FormInputCheckbox,
	},
	data() {
		return {
			cookieName: this.$root.options.cookieName || 'cookie-consent',
			cookieCategories: this.$root.options.cookieCategories || [],
			defaultCookieCategory: this.$root.options.defaultCookieCategory || 'default',
			selectedCategories: {},
			hidden: true,
		}
	},
	computed: {
		allCategoriesFormatted() {
			return this.cookieCategories.join(',')
		},
		selectedCategoriesFormatted() {
			return Object.entries(this.selectedCategories).reduce((categories, [category, value]) => {
				if (value) {
					categories.push(category);
				}
				return categories;
			}, []).join(',');
		}
	},
	methods: {
		onAccept() {
			this.hidden = true;
			this.$refs.modal.close();
		},
		onCollapse(e) {
			e.preventDefault();

			this.$refs.content.removeEventListener('transitionend', this.contentTransition);
			this.$refs.content.addEventListener('transitionend', this.contentTransition);

			this.$refs.content.style.maxHeight = `${this.$refs.content.scrollHeight}px`;

			setTimeout(() => {
				this.collapsed = !this.collapsed;
			}, 25);

			return false;
		},
		contentTransition() {
			this.$refs.content.removeEventListener('transitionend', this.contentTransition);
			this.$refs.content.style.maxHeight = '';
		},
		openModal() {
			this.$refs.modal.open();
		},
		onModalOpen() {
			this.resetOptions();
		},
		resetOptions() {
			const c = cookie.get(this.cookieName);
			const cats = c ? c.split(/\s?,\s?/) : [];

			this.hidden = !!c;
			this.selectedCategories = this.cookieCategories.reduce((categories, category) => {
				categories[category] =
					category === this.defaultCookieCategory ||
					(
						c ?
							cats.includes(category) :
							true
					);
				return categories;
			}, {});
		}
	},
	created() {
		this.resetOptions();
	}
}
</script>

<style>

</style>
